import { Injectable } from '@angular/core';
import { BaseService } from '../alcance/services/_base.service';

@Injectable({
  providedIn: 'root'
})
export class PlantaService extends BaseService{
    public override route: string = 'planta';
    override classname: string = 'PlantaService';
}
